// types
import { TeamMember, Benefit } from './types';

// images
import img1 from 'assets/images/avatars/img-1.jpg';
import img2 from 'assets/images/avatars/img-2.jpg';
import img3 from 'assets/images/avatars/img-3.jpg';
import img4 from 'assets/images/avatars/img-4.jpg';
import img5 from 'assets/images/avatars/img-5.jpg';
import img6 from 'assets/images/avatars/img-6.jpg';
import img7 from 'assets/images/avatars/img-7.jpg';
import img8 from 'assets/images/avatars/img-8.jpg';

const teamMembers: TeamMember[] = [
    {
        avatar: img1,
        name: 'Ana Russo',
        designation: 'CEO',
    },
    {
        avatar: img2,
        name: 'Danette Payne',
        designation: 'CTO',
    },
    {
        avatar: img3,
        name: 'Tammy Ward',
        designation: 'VP, Product Development',
    },
    {
        avatar: img4,
        name: 'Paul Moore',
        designation: 'Back-End Developer',
    },
    {
        avatar: img5,
        name: 'Harry Burris',
        designation: 'PHP Developer',
    },
    {
        avatar: img6,
        name: 'Patricia Ferraro',
        designation: 'Web Designer',
    },
    {
        avatar: img7,
        name: 'Robert Smith',
        designation: 'Graphic Designer',
    },
    {
        avatar: img8,
        name: 'Lindsay Clark',
        designation: 'Web Designer',
    },
    {
        avatar: img2,
        name: 'Lindsay Clark',
        designation: 'Front-End Developer',
    },
    {
        avatar: img4,
        name: 'Ernest Griffith',
        designation: 'PHP Developer',
    },
    {
        avatar: img6,
        name: 'Cecelia Poole',
        designation: 'Back-End Developer',
    },
    {
        avatar: img3,
        name: 'Morris Hall',
        designation: 'Graphic Designer',
    },
];

const benefits: Benefit[] = [
    {
        icon: 'shopping-bag',
        title: 'Retail',
        description: 'Customer loyalty programs, personalized marketing.',
    },
    {
        icon: 'heart',
        title: 'Healthcare',
        description: 'Patient engagement and appointment management.',
    },
    {
        icon: 'credit-card',
        title: 'Finance',
        description: 'Lead tracking and compliance monitoring.',
    },
    {
        icon: 'book-open',
        title: 'Education',
        description: 'Student and alumni management.',
    },
    {
        icon: 'home',
        title: 'Real Estate',
        description: 'Property management and client tracking',
    },
];

export { teamMembers, benefits };
